import { render, staticRenderFns } from "./BdAdAdd.vue?vue&type=template&id=36baa33a&"
import script from "./BdAdAdd.vue?vue&type=script&lang=js&"
export * from "./BdAdAdd.vue?vue&type=script&lang=js&"
import style0 from "./BdAdAdd.vue?vue&type=style&index=0&id=36baa33a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports